import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Modal } from 'components/Modal'
import {
  LeftSidebarView,
  ViewBody
} from 'components/Sidebar'
import * as ActivityDetailLevel from 'const/ActivityDetailLevel'
import Scrollbars from 'components/Scrollbars'
import {
  ModalMenu
} from 'components/Modal'
import {
  MenuItem
} from 'components/Menu'
import User from 'components/ControlledUser'
import ActivitiesComponent from 'components/Activities'
import classes from './UserActivities.module.scss'

export class UserActivities extends React.Component {
  static propTypes = {
    userId: PropTypes.number,
    isLoaded: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    cursor: PropTypes.string,
    currentUser: PropTypes.object,
    activities: PropTypes.array.isRequired,
    activitiesDetailLevel: PropTypes.number.isRequired,

    fetchUserActivities: PropTypes.func.isRequired,
    requestChangeUserSettings: PropTypes.func.isRequired,
    setUserId: PropTypes.func.isRequired
  }

  static DETAIL_LEVELS = [
    {
      id: ActivityDetailLevel.ALL,
      formattedMessageId: 'ACTIVITY_DETAIL_LEVEL_ALL'
    },
    {
      id: ActivityDetailLevel.IMPORTANT,
      formattedMessageId: 'ACTIVITY_DETAIL_LEVEL_IMPORTANT'
    },
    {
      id: ActivityDetailLevel.COMMENTS,
      formattedMessageId: 'ACTIVITY_DETAIL_LEVEL_COMMENTS'
    }
  ]

  componentWillUnmount = () => {
    this.handleClose()
  }

  handleClose = () => {
    this.props.setUserId(null)
  }

  handleDetailLevelChange = (detailLevel) => {
    this.props.requestChangeUserSettings({
      activitiesDetailLevel: detailLevel
    })
  }

  render () {
    const {
      userId,
      isLoaded,
      isLoading,
      cursor,
      currentUser,
      activities,
      activitiesDetailLevel,

      fetchUserActivities
    } = this.props

    return !!userId && (
      <Modal
        onClose={this.handleClose}
      >
        <LeftSidebarView
          className={classes.view}
          title={
            <User
              text
              id={userId}
            />
          }
        >
          <ViewBody
            className={classes.detailLevel}
          >
            <FormattedMessage id='ACTIVITY_DETAIL_LEVEL' />:
            {' '}
            <ModalMenu
              attachment='top center'
              targetAttachment='bottom center'
            >
              <a>
                <FormattedMessage
                  id={
                    UserActivities.DETAIL_LEVELS
                      .find(detailLevel => detailLevel.id === activitiesDetailLevel)
                      .formattedMessageId
                  }
                />
              </a>
              {UserActivities.DETAIL_LEVELS.map(detailLevel =>
                <MenuItem
                  key={detailLevel.id}
                  active={detailLevel.id === activitiesDetailLevel}
                  onClick={() => this.handleDetailLevelChange(detailLevel.id)}
                >
                  <FormattedMessage
                    id={detailLevel.formattedMessageId}
                  />
                </MenuItem>
              )}
            </ModalMenu>
          </ViewBody>
          <Scrollbars
            component={ViewBody}
          >
            <ActivitiesComponent
              context='notifications'
              isLoaded={isLoaded}
              isLoading={isLoading}
              lastLoadedId={cursor}
              currentUser={currentUser}
              detailLevel={activitiesDetailLevel}
              activities={activities}
              fetchActivities={fetchUserActivities}
              onDetailLevelChange={this.handleDetailLevelChange}
            />
          </Scrollbars>
        </LeftSidebarView>
      </Modal>
    )
  }
}

export default UserActivities
